export default function About() {
  return (
    <div className='min-h-screen py-16 text-left'>
      <h1 className='font-sans text-sm font-bold md:text-xl'>It's</h1>
      <h1 className='font-sans text-3xl font-bold md:text-5xl'>My Story</h1>
    </div>
  );
}
